import '../scss/view/prescription.scss';
import {
  ItemsForStatusUpdate,
  PatientDetailPrescriptionItem,
  PatientPrescriptionProps,
  PrescriptionStatus,
} from '../interface/interface';
import { useEffect, useState } from 'react';
import moment from 'moment';
import {
  filterPrescriptionStatus,
  renderStatusColor,
} from '../constant/constant';
import { DownCaretIcon, QRicon } from '../assets/svgImages';
import CustomModal from '../components/CustomModal';
import CustomQR from '../components/CustomQR';
import { PrescriptionDetail } from '../components/PrescriptionDetails';
import SingleRowTable from '../components/SingleRowTable';
import { Tooltip } from '../components/Tooltip';
import Toggle from '../components/ToggleComponent';
import Select, { components } from 'react-select';

const Prescriptions = (props: PatientPrescriptionProps) => {
  const [isStatusChangeModalOpen, setStatusChangeModalVisibility] =
    useState<boolean>(false);
  const [selectedItemsForStatusUpdate, setSelectedItemsForStatusUpdate] =
    useState<ItemsForStatusUpdate>();

  const [prescriptions, setPrescriptions] = useState<
    PatientDetailPrescriptionItem[]
  >([]);

  const [qrModal, OpenQRmodal] = useState<{
    isModalOpen: boolean;
    token: string | undefined;
  }>({ isModalOpen: false, token: undefined });

  const [showTooltip, setShowTooltip] = useState<string | null>(null);
  const [showPreferTooltip, setShowPreferTooltip] = useState<string>();

  useEffect(() => {
    const productCount: { [key: number]: number } = {};

    props.prescription.data?.forEach((prescription) => {
      const productId = prescription.product.id;
      if (productCount[productId]) {
        productCount[productId]++;
      } else {
        productCount[productId] = 1;
      }
    });

    props.prescription.data?.forEach((prescription) => {
      const productId = prescription.product.id;
      if (productCount[productId] > 1) {
        prescription.flag = true;
      }
    });

    setPrescriptions(props.prescription.data);
  }, [props.prescription.data]);

  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        <DownCaretIcon />
      </components.DropdownIndicator>
    );
  };

  return (
    <>
      <div className="my-6 bg-grey-50 rounded-md p-6">
        <div className="flex justify-between mb-6">
          <h2 className="text-2xl text-primary-blue-500 font-semibold">
            Medications
          </h2>
          <div className="mt-3 md:mt-0">
            <Select
              className="w-full md:w-60"
              value={props.filter.state}
              onChange={(selected) => props.filter.setter(selected)}
              options={[
                { label: 'All', value: 'all' },
                ...filterPrescriptionStatus,
              ]}
              isSearchable={false}
              components={{
                DropdownIndicator,
                IndicatorSeparator: () => null,
              }}
            />
          </div>
        </div>
        {prescriptions.length ? (
          <div>
            {prescriptions?.map((d, i) => {
              const prescriptionHeaders = [
                'Prescription Qty',
                'Repeat Qty',
                // 'Interval Limit',
              ];

              const prescriptionValues = [
                [
                  d?.eRx_qty?.toString() || '-',
                  d?.prescriedRepeats?.toString() || '-',
                  // `${d?.prescriedInterval?.toString() || '-'} days`,
                ],
              ];
              const productHeaders = [
                'Interval Limit',
                'Used Monthly Limit',
                // 'Total Qty Remaining',
                // 'Total Prescribed Qty',
                'Repeats Remaining',
              ];
              const productValues = [
                [
                  `${d?.prescriedInterval?.toString() || '-'} days`,

                  d?.product?.monthlyLimit
                    ? d?.product?.monthlyLimit?.toString()
                    : 'N/A',
                  // d?.remainingUnits.toString(),
                  // (
                  //   d?.prescriedQuantity *
                  //   (d?.prescriedRepeats + 1)
                  // )?.toString(),
                  d?.remainingRepeats <= 0
                    ? 'Last Repeat'
                    : d?.remainingRepeats?.toString(),
                ],
              ];

              return (
                <div
                  className="grid grid-cols-5 border border-secondary-pink-100 rounded-md mb-5"
                  key={i}
                >
                  <div
                    className="col-span-2 bg-secondary-pink-50 border-r border-secondary-pink-100 
                rounded-l-md px-7 py-3 flex flex-col justify-between"
                  >
                    <div>
                      <div className="flex justify-between items-center mb-2">
                        <h3 className="text-lg text-primary-blue-500 font-bold">
                          Prescription Details
                        </h3>
                        {d.eRxToken && (
                          <div>
                            <button
                              className="rounded bg-secondary-pink-100 shadow-sm p-2 relative"
                              onMouseEnter={() =>
                                setShowTooltip('showQR' + d.id)
                              }
                              onMouseLeave={() => setShowTooltip(null)}
                              onClick={() => {
                                OpenQRmodal({
                                  isModalOpen: true,
                                  token: d.eRxToken,
                                });
                              }}
                            >
                              {showTooltip === 'showQR' + d.id && (
                                <Tooltip
                                  className="left-1/2 top-11 z-20 transform -translate-x-1/2"
                                  text="Show QR"
                                />
                              )}
                              <QRicon />
                            </button>
                            {/* <button className="rounded bg-secondary-pink-100 shadow-sm p-2 ml-2">
                          <ShareIcon />
                        </button> */}
                          </div>
                        )}
                      </div>
                      {d.comment ? (
                        <div className="text-secondary-pink-700">
                          <PrescriptionDetail
                            label="Token:"
                            value={d?.eRxToken ? d?.eRxToken : '-'}
                          />
                          <p className="text-left">
                            {d?.comment ? d?.comment : '-'}
                          </p>
                        </div>
                      ) : (
                        <div className="text-secondary-pink-700">
                          <PrescriptionDetail
                            label="Token:"
                            value={d?.eRxToken === '' ? '-' : d?.eRxToken}
                          />
                          <PrescriptionDetail
                            label="Medication Name:"
                            value={d?.drugName}
                          />
                          <PrescriptionDetail
                            label="Brand Name:"
                            value={d?.brandName}
                          />
                          <PrescriptionDetail
                            label="Prescribed Dose:"
                            value={
                              d?.prescribedDosage === ''
                                ? '-'
                                : d?.prescribedDosage
                            }
                          />
                          <PrescriptionDetail
                            label="Prescribed by:"
                            value={d?.doctor ? `Dr. ${d.doctor}` : '-'}
                          />
                          <PrescriptionDetail
                            label="Prescribed on:"
                            value={d?.prescriptionDate ?? '-'}
                          />
                          <PrescriptionDetail
                            label="Medication Form:"
                            value={d?.medicationForm}
                          />
                          <PrescriptionDetail
                            label="Medication Strength:"
                            value={d?.medicationStrength}
                          />
                          <PrescriptionDetail
                            label="Route Admin:"
                            value={d?.routeAdmin}
                          />
                        </div>
                      )}
                    </div>
                    {!d.comment && (
                      <SingleRowTable
                        headerBgColor="bg-primary-blue-500"
                        tableWidth="min-w-full"
                        headers={prescriptionHeaders}
                        values={prescriptionValues}
                      />
                    )}
                  </div>
                  <div className="col-span-3 px-7 py-3 bg-white flex flex-col justify-between">
                    <div>
                      <div className="flex justify-between items-center mb-2">
                        <h3 className="text-lg text-secondary-pink-700 font-bold">
                          Matched Product Details
                        </h3>
                        <div className="flex justify-between items-center">
                          {d?.flag &&
                            d?.status === PrescriptionStatus.Active && (
                              <div className="ml-4 flex text-primary-blue-500">
                                <span className="text-sm font-semibold mt-1">
                                  Preferred Prescription?
                                </span>
                                <Toggle
                                  label=""
                                  value={d.isPreferable as boolean}
                                  onToggle={() => {
                                    props.setTriggerPreferable({
                                      id: d.id,
                                      isPreferable: d?.isPreferable,
                                    });
                                  }}
                                  readonly={false}
                                />
                                <div
                                  className="relative ml-3 cursor-pointer"
                                  onMouseEnter={() =>
                                    setShowPreferTooltip(
                                      `preferprescription-${d.id}`,
                                    )
                                  }
                                  onMouseLeave={() =>
                                    setShowPreferTooltip(undefined)
                                  }
                                >
                                  {showPreferTooltip ===
                                    `preferprescription-${d.id}` && (
                                    <Tooltip
                                      className="right-0 tooltip-500"
                                      text={`Toggle on to set this as your preferred prescription
                                    for ordering when multiple of the same medication options are available.`}
                                    />
                                  )}
                                  <i
                                    className="fa fa-question-circle-o text-primary-blue-500"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              </div>
                            )}

                          {d.status === PrescriptionStatus.Active ? (
                            <div
                              className={`ml-3 ${d.isIntervalReached > 0 ? 'bg-primary-red-100' : 'bg-secondary-green-100'}
                              rounded px-2 md:px-4 py-2 inline-flex items-center mb-2 md:mb-0 md:mr-2`}
                            >
                              <span
                                className={`w-2.5 h-2.5 rounded-full mr-2.5 ${
                                  d?.isIntervalReached > 0
                                    ? 'bg-primary-red-600'
                                    : 'bg-secondary-green-600'
                                }`}
                              ></span>
                              <span className="text-xs md:text-sm font-semibold text-primary-blue-500">
                                Interval {d?.isIntervalReached > 0 ? '' : 'not'}{' '}
                                reached
                              </span>
                            </div>
                          ) : (
                            <></>
                          )}
                          {d.remainingRepeats > 0 ? (
                            <div
                              className={`${renderStatusColor(d.status)} px-2.5 py-2 rounded flex items-center`}
                            >
                              <span
                                className={`${renderStatusColor(d.status, false)} rounded-full w-2.5 h-2.5 mr-3 inline-block`}
                              ></span>
                              <span className="text-sm font-semibold text-primary-blue-500">
                                {d.status}
                              </span>
                            </div>
                          ) : null}
                          {/* For Out of Repeats */}
                          {d.status === PrescriptionStatus.Active &&
                          d.remainingRepeats <= 0 &&
                          d.remainingUnits <= 0 ? (
                            <div
                              className={`${renderStatusColor(PrescriptionStatus.Cancelled)} px-2.5 py-2 rounded flex items-center ml-3`}
                            >
                              <span
                                className={`${renderStatusColor(PrescriptionStatus.Cancelled, false)} rounded-full w-2.5 h-2.5 mr-3 inline-block`}
                              ></span>
                              <span className="text-sm font-semibold text-primary-blue-500">
                                Out of Repeats
                              </span>
                            </div>
                          ) : null}
                          {[
                            PrescriptionStatus.Active,
                            PrescriptionStatus.Stopped,
                          ].includes(d.status as PrescriptionStatus) ? (
                            <span className="ml-3">
                              <button
                                className={`bg-white text-sm font-semibold px-2.5 py-1.5 w-24 rounded border-2 
                                  ${
                                    d.status === PrescriptionStatus.Active
                                      ? 'text-primary-red-600 border-primary-red-600'
                                      : 'text-secondary-green-600 border-secondary-green-600'
                                  }`}
                                onClick={() => {
                                  setStatusChangeModalVisibility(true);
                                  setSelectedItemsForStatusUpdate({
                                    prescriptionId: d.id,
                                    prescriptionCode: d.prescriptionCode,
                                    selectedValue: {
                                      value:
                                        d.status === PrescriptionStatus.Active
                                          ? PrescriptionStatus.Stopped
                                          : PrescriptionStatus.Active,
                                      label:
                                        d.status === PrescriptionStatus.Active
                                          ? 'Stopped'
                                          : 'Resume',
                                    },
                                  });
                                }}
                              >
                                {d.status === PrescriptionStatus.Active
                                  ? 'Stop'
                                  : 'Resume'}
                              </button>
                            </span>
                          ) : null}
                        </div>
                      </div>
                      <div className="grid grid-cols-5 mb-14">
                        <div className="col-span-1">
                          <div
                            className="bg-secondary-cornflowerblue-600 text-white font-semibold rounded-full 
                        text-xxs uppercase p-2 inline-block w-max"
                          >
                            {d?.product?.name ? 'Matched' : 'Unmatched'} product
                          </div>
                          <div className="mt-1.5">
                            <img
                              className="w-1/2 md:w-full xl:w-28"
                              src={
                                d?.product?.imgUrl === ''
                                  ? '/default-image.png'
                                  : !d?.product?.imgUrl
                                    ? '/default-image.png'
                                    : d.product.imgUrl
                              }
                              alt="medicine image"
                            />
                          </div>
                        </div>
                        <div className="col-span-4">
                          <div className="text-primary-blue-500">
                            <PrescriptionDetail
                              label="Product Name:"
                              value={d?.product?.name ? d?.product?.name : '-'}
                            />
                            <PrescriptionDetail
                              label="Script Number:"
                              value={
                                d?.prescriptionCode ? d.prescriptionCode : '-'
                              }
                            />
                            <PrescriptionDetail
                              label="Prescription Expiry:"
                              value={
                                d.comment
                                  ? '-'
                                  : moment(d?.prescriptionExpiry).format(
                                      'DD/MM/YYYY',
                                    )
                              }
                            />
                            <PrescriptionDetail
                              label="Product Details:"
                              value={d.product.description}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {d.status === PrescriptionStatus.Active && (
                      <SingleRowTable
                        headerBgColor="bg-secondary-pink-700"
                        tableWidth="min-w-full"
                        headers={productHeaders}
                        values={productValues}
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-center text-primary-blue-500">
            Prescriptions Not Exist
          </p>
        )}
      </div>
      <CustomModal
        isOpen={isStatusChangeModalOpen}
        onClose={() => setStatusChangeModalVisibility(false)}
        header="Confirmation"
        footer={
          <>
            <button
              className="mr-4 bg-primary-blue-500 text-white px-4 py-2 w-24 rounded"
              onClick={() => {
                if (selectedItemsForStatusUpdate) {
                  props.addPrescriptionModalParams.updatePrescriptionStatus(
                    selectedItemsForStatusUpdate?.selectedValue,
                    selectedItemsForStatusUpdate?.prescriptionId,
                  );
                  setStatusChangeModalVisibility(false);
                }
              }}
            >
              Yes
            </button>
            <button
              className="bg-white border border-solid border-primary-blue-500 text-primary-blue-500 w-24 px-4 py-2 rounded"
              onClick={() => setStatusChangeModalVisibility(false)}
            >
              Cancel
            </button>
          </>
        }
      >
        Do you really want to Change the status of{' '}
        <b className="text-primary-blue-500">
          {selectedItemsForStatusUpdate?.prescriptionCode}
        </b>{' '}
        to{' '}
        <b className="text-primary-blue-500">
          {selectedItemsForStatusUpdate?.selectedValue?.label}
        </b>{' '}
        ?
      </CustomModal>
      <CustomModal
        isOpen={(qrModal.isModalOpen && qrModal.token) as boolean}
        onClose={() => OpenQRmodal({ isModalOpen: false, token: undefined })}
        header={'QR Code'}
        footer={undefined}
      >
        <div>
          <CustomQR value={qrModal?.token as string} size={300} />
        </div>
      </CustomModal>
    </>
  );
};

export default Prescriptions;
